module.exports = __webpack_public_path__ + "static/media/Logo - Teste_2.5c8143a5.png";